<section class="authentication">
    <article>
        <mat-card>
            <mat-card-content>
                <form *ngIf="authenticationForm" [formGroup]="authenticationForm" (ngSubmit)="onSubmit()">
                    <!-- <div class="text-center">
                        <img src="../../assets/svg/icon.svg" />
                    </div> -->
                    <div class="text-center">
                        <h3><img src="../../assets/images/biswa_bangla_login_logo.png" /></h3>
                    </div>

                    <div fxLayout="column" fxLayoutAlign="center">
                        <div fxFlex="100">
                            <mat-form-field appearance="legacy">
                                <mat-label>Email address</mat-label>
                                <input type="email" matInput placeholder="Ex. abc@example.com" formControlName="Email"
                                    autocomplete="off">
                                <mat-icon matSuffix>alternate_email</mat-icon>
                                <mat-hint *ngIf="!isInitial" align="end">
                                    <a href="javascript:void(0);" (click)="onChange()">Change</a>
                                </mat-hint>
                                <mat-hint align="start">Please provide your email</mat-hint>
                                <mat-error>Please provide valid email</mat-error>
                            </mat-form-field>
                        </div>
                        <div fxFlex="100">
                            <mat-form-field appearance="legacy">
                                <mat-label>Password</mat-label>
                                <input type="password" matInput placeholder="********" formControlName="AdminPassword"
                                    autocomplete="off">
                                <mat-icon matSuffix>lock</mat-icon>
                                <mat-hint>Please provide your password</mat-hint>
                                <mat-error>Please provide valid password</mat-error>
                            </mat-form-field>
                        </div>
                        <div fxFlex="100" *ngIf="!isInitial">
                            <mat-form-field appearance="legacy">
                                <mat-label>Validate OTP</mat-label>
                                <input #inputOtpField type="password" size="6" maxlength="6" matInput formControlName="InputOTP">
                                <mat-icon matSuffix>lock_open</mat-icon>
                                <mat-hint align="end">
                                    <a href="javascript:void(0);" [ngClass]="{'disabled': !resendOTP}"
                                        (click)="resendOTP ? onResendOTP() : ''">
                                        <span *ngIf="!resendOTP" [innerHTML]="'(00:' + resendOTPTimer + ')'"></span>
                                        Resend OTP
                                    </a>
                                </mat-hint>
                            </mat-form-field>
                        </div>
                        <div fxFlex="100">
                            <button mat-raised-button color="primary" type="submit">{{ action }}</button>
                            <p>Have forgot your password? <a href="javascript:void(0);"
                                    (click)="onForgotPassword()">Click Here</a>
                            </p>
                        </div>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </article>
</section>